import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { RouterService } from '../../services/routerService';
import { SetTenderTeamMemberFileAccessDto, TenderTeamMemberSummaryDto } from '../../models/tender.team.members/tender.team.member.models';
import { TenderTeamMemberService } from '../../services/tender.team.member.service';
import { PermissionsHub } from '../../signalr/permissions.hub';
import { AuthService } from '../../auth/auth.service';
import { Configuration } from '../../configuration';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';


@Component({
    selector: 'team-members',
    template: require('./search.component.html'),
    styles: [require('../account.management/personal.account.shared.css'), require('./search.component.css')]
})
export class TeamMemberSearchComponent implements OnInit {
    maxTeamMembers: number;
    teamMembers: Array<TenderTeamMemberSummaryDto>;

    memberToDelete: TenderTeamMemberSummaryDto;
    user: LoggedInUser;

    @BlockUI() blockUi: NgBlockUI;

    constructor(private readonly routerService: RouterService,
        private readonly teamMemberService: TenderTeamMemberService,
        private readonly authService: AuthService,
        private readonly configuration: Configuration,
        private readonly loggedInUserService: LoggedInUserService) {
        this.teamMembers = [];
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');
        this.user = this.loggedInUserService.getCurrentUser();
        this.loadTeamMembers();

        PermissionsHub.startHub(this.authService, this.configuration, this.user.userId);
        PermissionsHub.subscribeToHubEvent('RefreshTendersTeamMembers', (data: any) => {
            this.loadTeamMembers();
        });
    }

    ngOnDestroy() {
        document.body.classList.remove('personal-account-fit');
        $('#delete-modal').modal('hide');
    }

    private loadTeamMembers() {
        this.blockUi.start();

        this.teamMemberService.getMaxTeamMembers().subscribe((response: number) => {
            this.maxTeamMembers = response;
        });

        this.teamMemberService.getAll().subscribe((response: Array<TenderTeamMemberSummaryDto>) => {
            this.teamMembers = response;
        },
            () => { this.blockUi.stop(); },
            () => { this.blockUi.stop(); });
    }

    hasMaxTeamMembers() {
        return this.teamMembers &&
            this.maxTeamMembers &&
            this.teamMembers.length >=
            this.maxTeamMembers;
    }

    resendInvitation(id: number) {
        this.blockUi.start();
        this.teamMemberService.resendInvitation(id)
            .subscribe(() => { this.blockUi.stop(); }, () => { this.blockUi.stop(); });
    }

    deleteTeamMember(teamMember: TenderTeamMemberSummaryDto) {
        this.memberToDelete = teamMember;

        $('#delete-modal').modal();
    }

    confirmDelete() {
        this.blockUi.start();

        this.teamMemberService.delete(this.memberToDelete.id, this.memberToDelete.rowVersion)
            .subscribe(() => {
                this.loadTeamMembers();
                $('#delete-modal').modal('hide');
                this.memberToDelete = null;
            },
                () => { this.blockUi.stop(); },
                () => { this.blockUi.stop(); });
    }

    toggleFileAccess(teamMember: TenderTeamMemberSummaryDto) {

        var dto = new SetTenderTeamMemberFileAccessDto();
        dto.fileAccess = !teamMember.fileAccess;
        dto.id = teamMember.id;

        this.teamMemberService.setFileAccess(dto).subscribe(() => {

        });

    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tender.team.members/search.component.ts